export const Roles = {
  Tutor: "TUTOR",
  Lecturer: "LECTR",
  Admin: "ADMIN",
  SchoolAdmin: "SCADM"
}